module.exports = __webpack_public_path__ + "media/images/recruit/recruitmentlist/icon-order-list-080fbd1ab248f715d083bb6ceb340ec0.svg";